import { Container, Typography } from "@mui/material";

export default function SchedulerEmptyScreen() {
  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h3">
        Select a task on the left to continue
      </Typography>
    </Container>
  )
}